import { render, staticRenderFns } from "./AssignmentsSection.vue?vue&type=template&id=0e411f9b&scoped=true"
import script from "./AssignmentsSection.vue?vue&type=script&lang=ts"
export * from "./AssignmentsSection.vue?vue&type=script&lang=ts"
import style0 from "./AssignmentsSection.vue?vue&type=style&index=0&id=0e411f9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e411f9b",
  null
  
)

export default component.exports